 
import React from "react";
import { Modal, Button } from "antd";
import SettingIcon from "../../assets/images/settings-icon.svg";
import FleshIcon from "../../assets/images/auto-theme.svg";
import DarkIcon from "../../assets/images/dark-theme.svg";
import LightIcon from "../../assets/images/light-theme.svg";

export default function ThemeModal({ open, onClose, switchTheme, switchThemeval }) {
  return (
    <Modal
      title={
        <div className="header-theme">
          <img width={25} src={SettingIcon} alt="Theme" />
          <span>Theme</span>
        </div>
      }
      className="theme-modal"
      open={open}
      onCancel={onClose}
      footer={false}
    >
      <div className="theme-change-outer">
        <Button icon={<img src={FleshIcon} alt="Auto" />} onClick={() => switchTheme("auto")}>
          Auto
        </Button>
        <Button icon={<img src={DarkIcon} alt="Dark" />} onClick={() => switchTheme("dark")}>
          Dark
        </Button>
        <Button icon={<img src={LightIcon} alt="Light" />} onClick={() => switchTheme("light")}>
          Light
        </Button>
      </div>
    </Modal>
  );
}
